/**
 * environment.ts - the ONE place that reads Vite environment variables.
 *
 * Section 62's "Do not hard-code API URLs" rule means every other file in
 * the app imports `env` from here instead of reading `import.meta.env`
 * directly - if the API base path or any other environment-specific value
 * ever needs to change, this is the only file that changes.
 *
 * Vite only exposes variables prefixed with VITE_ to the browser bundle
 * (anything else in a `.env` file stays server/build-side only) - see
 * Section 56: "Frontend environment variables may include public
 * configuration only", never secrets.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  appName: 'TripLink',
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'rw', 'sw', 'zh-CN', 'fr', 'es'] as const,
  // How long (ms) booking-in-progress state survives a page refresh
  // (Section 9.3) - kept short since it's meant to survive an accidental
  // reload, not to be a long-term draft-saving feature.
  bookingDraftTtlMs: 30 * 60 * 1000,
};

export type SupportedLanguage = (typeof env.supportedLanguages)[number];
